export const MONEY_TYPE_TRANSLATION_KEYS = {
	realMoney: "game-launcher.real-money",
	realBonus: "game-launcher.real-bonus",
	funBonus: "game-launcher.fun-bonus",
};
